module.exports = __webpack_public_path__ + "static/media/Brian Cheng_Photo.364d1c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Brian Cheng_Photo.jpg
// module id = 181
// module chunks = 0